import React, { Component } from 'react'
import { FeatureErrorFallback } from './ErrorFallback'

export class RouteErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    if (window.errorReporting) {
      window.errorReporting.captureException(error, {
        component: this.props.name || 'Route',
        errorInfo,
      })
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (this.state.hasError) {
      return (
        <FeatureErrorFallback
          error={this.state.error}
          resetErrorBoundary={this.handleReset}
          featureName={this.props.name || 'Page'}
        />
      )
    }

    return this.props.children
  }
}